/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespCollectionSpotlightItem_item = {
    readonly title: string | null;
    readonly linkData: {
        readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
    };
    readonly image: {
        readonly imageUrl: string | null;
        readonly imageWidth: string | null;
        readonly imageHeight: string | null;
    } | null;
    readonly " $refType": "HpRespCollectionSpotlightItem_item";
};
export type HpRespCollectionSpotlightItem_item$data = HpRespCollectionSpotlightItem_item;
export type HpRespCollectionSpotlightItem_item$key = {
    readonly " $data"?: HpRespCollectionSpotlightItem_item$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespCollectionSpotlightItem_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespCollectionSpotlightItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CollectionSpotlightImageType",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageHeight",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CollectionSpotlightItem",
  "abstractKey": null
};
(node as any).hash = '51cd4e490ad619148ef58958178319f0';
export default node;
